export const STATUS_MAP = {
  PICKED_UP: "Picked",
  CLEARANCE_EVENT: "Document Verification",
  CUSTOMS_CLEARANCE: "Customs Clearance",
  EXCEPTIONS: "Exceptions",
  OUT_FOR_DELIVERY: "Out for Delivery",
  DELIVERED: "Delivered"
};
